import React, { useState, useEffect } from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { resetUnauthorizedFlag } from '../../api';

const Unauthorized = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    // 立即清除登录信息（确保清除）
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_username');
    
    // 重置API拦截器中的跳转标志（允许用户重新登录）
    resetUnauthorizedFlag();
    
    // 阻止页面继续加载其他组件的数据
    // 如果当前不在未授权页面，强制跳转
    if (window.location.hash !== '#/unauthorized' && window.location.hash !== '#/login') {
      window.location.replace('#/unauthorized');
      return;
    }

    // 倒计时跳转
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // 使用 replace 确保不留下历史记录
          window.location.replace('#/login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoLogin = () => {
    navigate('/login', { replace: true });
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)',
    }}>
      <Result
        icon={<ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />}
        title="当前未登录"
        subTitle={`检测到您未登录或登录已过期，${countdown} 秒后自动跳转到登录页面`}
        extra={[
          <Button type="primary" key="login" onClick={handleGoLogin}>
            立即前往登录
          </Button>,
        ]}
      />
    </div>
  );
};

export default Unauthorized;

